import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';

@Component({

  selector: 'register',

  templateUrl: './register.component.html',

})

export class RegisterComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private router: Router,
    private notifyService: NotificationService,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private otherService: OtherService

  ) { }

  appName: string = `${(<any>window).appName}`;

  webAppName = (<any>window).webAppName;

  password: boolean = false;

  password2: boolean = false;

  timer: number = 0;

  otp: boolean = false;

  repet: boolean = true;

  timeLeft: number = 120;

  interval: any;

  RegisterModel = new FormGroup({
    strUserName: new FormControl(),
    strIntroducedMobile: new FormControl(),
    strFullName: new FormControl(),
    strPassword: new FormControl(),
    strPassword2: new FormControl(),
  });

  OtpModel = new FormGroup({
    strUserName: new FormControl(),
    iOTP: new FormControl(),
  });

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ((params['otp'])) {
        this.otp = !this.otp;
        this.RegisterModel.controls["strUserName"].setValue((params['otp']));
        this.startTimer();
      }
    });
  }

  changeType() {
    this.password = !this.password;
  }

  changeType2() {
    this.password2 = !this.password2;
  }

  register = async () => {
    var model = this.RegisterModel.value;
    if (model.strUserName.length != 11) {
      this.notifyService.showError('شماره وارد شده معتبر نیست');
      return;
    }
    if (model.strFullName == null || model.strFullName == '') {
      this.notifyService.showError('لطفا نام کامل خود را وارد کنید');
      return;
    }
    if (model.strPassword == null || model.strPassword == '') {
      this.notifyService.showError('لطفا رمز عبور را  وارد کنید');
      return;
    }
    if (model.strPassword != model.strPassword2) {
      this.notifyService.showError('رمز عبور با تکرارش برابر نیست');
      return;
    } else {
      const resp = await axios.post('RegisterRadyabUser', model);
      if (resp.data.Result != 1) {
        this.notifyService.showError(resp.data.Message);
        return;
      } else {
        this.otp = true;
        this.startTimer();
      }
    }

  };

  chekOtp = async () => {
    var model = this.OtpModel.value;

    model.strUserName = this.RegisterModel.controls['strUserName'].value;
    if (model.iOTP == null || model.otp == '') {
      this.notifyService.showError('لطفا کد دریافتی را وارد کنید');
      return;
    }
    const resp = await axios.post('CheckRegisterRadyabOTP', model);
    if (resp.data.Result != 1) {
      this.notifyService.showError(resp.data.Message);
      return;
    }
    if (resp.data.Result == 1) {
      //this.notifyService.showSuccess('ورود موفقیت آمیز');
      localStorage.setItem('Session', this.gurdService.encrypt(resp.data.strSession));
      localStorage.setItem('ID', this.gurdService.encrypt(resp.data.Id));
      localStorage.setItem('companyName', this.gurdService.encrypt(resp.data.strCompanyName));
      localStorage.setItem('FullName', this.gurdService.encrypt(resp.data.strFullName));
      localStorage.setItem('UnitID', this.gurdService.encrypt(resp.data.strUnitID));
      var model2 = {
        iSystemUser: resp.data.Id,
        strSession: resp.data.strSession,
      }
      const resp2 = await axios.post("GetRadyabUserAbility2", model2) as any;

      if (resp2.data.ISSessionExpired == true) {

        this.otherService.removeLocalStorage();

        // this.router.navigate(['login']);

        this.router.navigate(['login'], { queryParams: { error: '126' } });


        return;

      }
      resp2.data = JSON.parse(resp2.data);
      var acsess = {
        bEnableAddCar: resp.data.bEnableAddCar,
        bEnableSOS: resp.data.bEnableSOS,
        bEnableIntroducedMobile: resp.data.bEnableIntroducedMobile,
        bSupport: resp.data.bSupport,
        bEnableEditCar: resp.data.bEnableEditCar,
        bEnableDashboard: resp.data.bEnableDashboard,
        bEnableAddID: resp.data.bEnableAddID,
        bEnableGeoFance: resp.data.bEnableGeoFance,
        bEnableCommand: resp.data.bEnableCommand,
        bEnableCarRvenues: resp.data.bEnableCarRvenues,
        bEnableTiket: resp.data.bEnableTiket,
        bShop: resp.data.bShop,
      } as any;
      for (let index = 0; index < resp2.data.length; index++) {

        acsess[resp2.data[index].strXenotakAbility] = resp2.data[index].bHas == 0 ? false : true
      }
      localStorage.setItem("menu", this.gurdService.encrypt(JSON.stringify(acsess)));
      localStorage.setItem('UserName', this.gurdService.encrypt(this.RegisterModel.controls['strUserName'].value));
      localStorage.setItem('pass', this.gurdService.encrypt(this.RegisterModel.controls['strPassword'].value));
      this.router.navigate(['/']);
    }
  };

  createOtp = async (sendAgain?: any) => {
    var model = {
      strUserName: this.RegisterModel.controls['strUserName'].value
    };
    const resp = await axios.post('CreateOTP4Radyab', model);
    if (resp.data.iResult == 1) {
      if (sendAgain) {
        this.notifyService.showSuccess('کد تایید مجددا پیامک شد ');

      }
      else {
        this.notifyService.showSuccess('با موفیقت ارسال شد');

      }
      this.repet = !this.repet;
      this.startTimer();
    }
    if (resp.data.Result != 1) {
      this.notifyService.showError(resp.data.Message);
      return;
    }
  };

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 120;
        this.pauseTimer();
        this.repet = !this.repet;
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
}
